import { render, staticRenderFns } from "./AppEchartDoughnut.vue?vue&type=template&id=6d32a3a0&"
import script from "./AppEchartDoughnut.vue?vue&type=script&lang=js&"
export * from "./AppEchartDoughnut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d32a3a0')) {
      api.createRecord('6d32a3a0', component.options)
    } else {
      api.reload('6d32a3a0', component.options)
    }
    module.hot.accept("./AppEchartDoughnut.vue?vue&type=template&id=6d32a3a0&", function () {
      api.rerender('6d32a3a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/components/charts/echart/AppEchartDoughnut.vue"
export default component.exports